export default __webpack_public_path__ + "static/media/CAL30250.8eae1575.jpg";